import { LoadingSpinner } from "components/LoadingSpinner";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useListFilesQuery } from "store/queries/chat";
import styled from "styled-components";
import { IOpenAiFile } from "types/Chat";

const FileName = styled.span`
  color: #0066cc;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

function FilesTable() {
  const navigate = useNavigate();
  const { data: filesData, isLoading } = useListFilesQuery();

  const parsedFiles = useMemo(() => {
    if (!filesData?.db) return [];
    return filesData.db
      .map((file: IOpenAiFile) => ({
        fileId: file.fileId,
        name: file.name,
        identifier: file.identifier,
        purpose: file.purpose,
        createdAt: new Date(file.createdAt).toLocaleDateString(),
        createdAtDate: new Date(file.createdAt),
      }))
      .sort((a, b) => b.createdAtDate.getTime() - a.createdAtDate.getTime());
  }, [filesData]);

  const nameBody = useCallback(
    (rowData: any) => {
      return (
        <FileName onClick={() => navigate(`/chatbot/files/${rowData.fileId}`)}>
          {rowData.name}
        </FileName>
      );
    },
    [navigate]
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <DataTable
      rows={10}
      paginator
      stripedRows
      className="p-fluid"
      value={parsedFiles}
      responsiveLayout="scroll"
      style={{ cursor: "pointer" }}
      emptyMessage="No files to show."
    >
      <Column
        field="name"
        style={{ minWidth: "200px" }}
        header="Name"
        body={nameBody}
      />
      <Column
        field="identifier"
        style={{ minWidth: "200px" }}
        header="Identifier"
      />
      <Column field="purpose" style={{ minWidth: "150px" }} header="Purpose" />
      <Column
        field="createdAt"
        style={{ minWidth: "120px", maxWidth: "150px" }}
        header="Created"
      />
    </DataTable>
  );
}

export { FilesTable };
